import * as React from 'react';
import {
  IconMapBus16,
  IconMapMetroEkb16,
  IconMapMetroKzn16,
  IconMapMetroMsk16,
  IconMapMetroNN16,
  IconMapMetroNovosib16,
  IconMapMetroSam16,
  IconMapMetroSpb16,
  IconMapWalk16,
} from '@cian/ui-kit-design-tokens/icons';

import { TTransportType, TUndergroundType } from '../../../../../../types/newbuildingsCompare';

const METRO_ICONS_MAP: Record<TUndergroundType, React.ReactNode> = {
  mow: <IconMapMetroMsk16 color="current_color" />,
  spb: <IconMapMetroSpb16 color="current_color" />,
  ekb: <IconMapMetroEkb16 color="current_color" />,
  kzn: <IconMapMetroKzn16 color="current_color" />,
  nsk: <IconMapMetroNovosib16 color="current_color" />,
  smr: <IconMapMetroSam16 color="current_color" />,
  nn: <IconMapMetroNN16 color="current_color" />,
};

export function metroIconMapper(undergroundType?: TUndergroundType | null): React.ReactNode {
  return METRO_ICONS_MAP[undergroundType ?? 'mow'] ?? METRO_ICONS_MAP.mow;
}

export function transportTypeIconMapper(transportType?: TTransportType | null): React.ReactNode {
  return transportType === 'walk' ? <IconMapWalk16 /> : <IconMapBus16 />;
}

/**
 * Цвет линии метро приходит с бэка как hex без решётки. Красим обёртку, а иконка метро
 * наследует цвет через color="current_color".
 */
export function getTransportPointColorStyle(color?: string | null): React.CSSProperties | undefined {
  return color ? { color: `#${color}` } : undefined;
}
